// extracted by mini-css-extract-plugin
export default {"titleWrapper":"titleWrapper__X6jkk","checkbox":"checkbox__OdvhL"};